import { render, staticRenderFns } from "./TecladoLogin.vue?vue&type=template&id=8b854bf4"
import script from "./TecladoLogin.vue?vue&type=script&lang=js"
export * from "./TecladoLogin.vue?vue&type=script&lang=js"
import style0 from "./TecladoLogin.vue?vue&type=style&index=0&id=8b854bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports